// @ts-nocheck
// Stores on catalog-v2 (catalogRevision NDR_V2): this file only hands off to no-drill-category-config-v2.js,
// which is the source of truth for steps, options, controls and sizes. Everything else below serves the
// older V1 builder pages only; its step orders, cord control and size limits do not apply to catalog-v2.
(function attachCategoryConfig(root, factory) {
  const catalogData = root.NoDrillCatalogData
    || (typeof module === 'object' && module.exports ? require('./no-drill-catalog-data.js') : null);
  const v2Factory = root.NoDrillCategoryConfigV2
    || (typeof module === 'object' && module.exports ? require('./no-drill-category-config-v2.js') : null);
  const api = factory(catalogData, v2Factory);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.NoDrillCategoryConfig = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function createCategoryConfig(catalogData, v2Factory) {
  'use strict';

  if (!catalogData) throw new Error('No Drill customer catalog data is required.');

  if (catalogData.catalogRevision === 'NDR_V2') {
    if (!v2Factory || typeof v2Factory.create !== 'function') {
      throw new Error('No Drill V2 category configuration is required.');
    }
    return v2Factory.create(catalogData);
  }

  function createRetiredV2CategoryConfig(data) {
    function clone(value) {
      return JSON.parse(JSON.stringify(value));
    }

    function conditionsMatch(conditions, selections) {
      return !conditions || Object.entries(conditions).every(
        ([id, allowed]) => allowed.includes((selections || {})[id]),
      );
    }

    function isGroupActive(group, selections) {
      return conditionsMatch(group.activeWhen, selections || {});
    }

    function availableOptions(group, selections) {
      const selected = selections || {};
      if (!isGroupActive(group, selected)) return [];
      if ((group.dependsOn || []).some((id) => !selected[id])) return [];
      return (group.options || []).filter((option) => conditionsMatch(option.requires, selected));
    }

    function availableControls(category, selections) {
      const selected = selections || {};
      return (category.controlOrder || [])
        .map((id) => ({ id, ...category.controls[id] }))
        .filter((control) => control.enabled && conditionsMatch(control.requires, selected));
    }

    function defaultOption(group, selections) {
      const configured = (group.defaults || []).find(
        (entry) => conditionsMatch(entry.when, selections || {}),
      );
      return configured?.option || group.defaultOption || '';
    }

    const family = data.roller?.families?.find((item) => item.id === 'NDR-V2-RL-BO-001');
    const variants = (data.roller?.variants || []).filter(
      (variant) => variant.familyId === family?.id && variant.fabricType === 'blackout',
    );
    const buildEligible = Boolean(family?.buildEligible && variants.length === 5);
    const headrail = 'no-drill-square-cassette';
    const categories = {
      'roller-shades': {
        id: 'roller-shades',
        label: 'Roller Shades',
        displayLabel: 'Roller Shades',
        shortLabel: 'Roller',
        catalogRevision: data.catalogRevision,
        catalogEligible: buildEligible,
        configurationEnabled: buildEligible,
        buildEligible,
        launchEligible: false,
        checkoutEnabled: false,
        priceStatus: 'quote-pending',
        mediaStatus: 'placeholder',
        validationLabel: 'No-Drill Square Cassette preview. Final production dimensions and pricing are not yet available.',
        mountValidation: { status: 'provisional-finalization-pending' },
        customizerFlow: [
          'installation_mount',
          'fabric_color',
          'headrail_style',
          'measurements',
          'control_method',
          'window_details',
          'review',
        ],
        controlPreviewInstallation: 'no-drill',
        requireExplicitControlChoice: true,
        lockedOptionLabels: {
          fabric_type: { blackout: 'Blackout Roller Shades' },
        },
        measurement: {
          status: 'unresolved',
        },
        optionGroups: [
          {
            id: 'installation_method',
            stage: 'installation',
            label: 'Installation method',
            required: true,
            defaultOption: 'no-drill',
            display: 'cards',
            options: [
              {
                id: 'no-drill',
                label: 'No-Drill Mount',
                note: 'No-drill inside-mount installation.',
              },
            ],
          },
          {
            id: 'fabric_type',
            label: 'Fabric type',
            required: true,
            defaultOption: 'blackout',
            display: 'cards',
            options: [
              {
                id: 'blackout',
                label: 'Blackout',
                note: 'Opaque fabric for room darkening. Perimeter light gaps can remain.',
              },
            ],
          },
          {
            id: 'fabric_family',
            label: 'Fabric collection',
            required: true,
            dependsOn: ['fabric_type'],
            waitingLabel: 'Choose the Blackout fabric type first.',
            defaultOption: family?.id || '',
            display: 'cards',
            options: family ? [{
              id: family.id,
              label: family.label,
              requires: { fabric_type: ['blackout'] },
            }] : [],
          },
          {
            id: 'fabric_color',
            label: 'Color',
            note: 'Color labels are provisional. Confirm the final choice with a physical sample.',
            required: true,
            dependsOn: ['fabric_family'],
            waitingLabel: 'Choose the fabric collection first.',
            display: 'cards',
            options: variants.map((variant) => ({
              id: variant.id,
              label: variant.label,
              requires: { fabric_type: ['blackout'], fabric_family: [family.id] },
            })),
          },
          {
            id: 'headrail_style',
            stage: 'headrail',
            label: 'Headrail style',
            required: true,
            dependsOn: ['installation_method'],
            waitingLabel: 'Confirm the installation method first.',
            defaultOption: headrail,
            display: 'cards',
            options: [
              {
                id: headrail,
                label: 'No-Drill Square Cassette',
                fabricWrapped: false,
                requires: { installation_method: ['no-drill'] },
              },
            ],
          },
          {
            id: 'hardware_finish',
            stage: 'headrail',
            label: 'Hardware finish',
            requiredWhen: { headrail_style: [headrail] },
            activeWhen: { headrail_style: [headrail] },
            dependsOn: ['headrail_style'],
            waitingLabel: 'Confirm the headrail first.',
            defaultOption: '',
            display: 'cards',
            options: [
              { id: 'white', label: 'White', availabilityStatus: 'provisional', requires: { headrail_style: [headrail] } },
              { id: 'beige', label: 'Beige', availabilityStatus: 'provisional', requires: { headrail_style: [headrail] } },
              { id: 'gray', label: 'Gray', availabilityStatus: 'provisional', requires: { headrail_style: [headrail] } },
              { id: 'black', label: 'Black', availabilityStatus: 'provisional', requires: { headrail_style: [headrail] } },
            ],
          },
          {
            id: 'mount_location',
            stage: 'installation',
            label: 'Mount location',
            required: true,
            dependsOn: ['installation_method'],
            defaultOption: 'inside',
            hideWhenSingleOption: true,
            display: 'cards',
            options: [
              { id: 'inside', label: 'Inside Mount', requires: { installation_method: ['no-drill'] } },
            ],
          },
        ],
        defaultMount: 'no-drill-inside',
        mounts: {
          'no-drill-inside': {
            label: 'Inside mount · No-Drill Square Cassette',
            enabled: true,
            allowedMountTypes: ['inside'],
            surchargeCents: 0,
            note: 'Final dimensions and deductions are not yet available.',
          },
        },
        controlOrder: ['cordless', 'motorized'],
        controls: {
          cordless: {
            enabled: true,
            label: 'Cordless',
            surchargeCents: 0,
            requires: { headrail_style: [headrail] },
          },
          motorized: {
            enabled: true,
            label: 'Motorized',
            surchargeCents: 0,
            requires: { headrail_style: [headrail] },
          },
        },
        upgrades: {},
        accessories: {},
        accessoryNone: {
          id: 'none',
          label: 'No accessories',
          note: 'No accessories are available for this configuration.',
        },
        priceBands: [],
      },
    };
    const orderPricing = { discountTiers: [] };

    function getCategory(id) {
      return categories[id] ? clone(categories[id]) : null;
    }

    function listCatalogCategories() {
      return Object.values(categories).filter((category) => category.catalogEligible).map(clone);
    }

    function buildRules(id) {
      const category = getCategory(id);
      if (!category) throw new Error(`Unknown no-drill category: ${id}`);
      return {
        ...category,
        version: 2,
        mode: 'catalog-v2',
        currency: 'USD',
        checkoutEnabled: false,
        orderPricing: clone(orderPricing),
      };
    }

    return {
      categories,
      orderPricing,
      getCategory,
      listCatalogCategories,
      buildRules,
      isGroupActive,
      availableOptions,
      availableControls,
      defaultOption,
    };
  }

  const CONTROL_SAFETY_NOTE =
    'Uses a continuous-loop chain with a secured tension device. No free-hanging pull cord.';

  const commonColors = [
    { id: 'warm-white', label: 'Warm White', swatchHex: '#eeeae1' },
    { id: 'sand', label: 'Sand', swatchHex: '#cdbb9c' },
    { id: 'graphite', label: 'Graphite', swatchHex: '#4c4c4a' },
  ];

  function controlLadder(cordlessCents, motorizedCents) {
    return {
      cord: { enabled: true, label: 'Cord loop', surchargeCents: 0, note: CONTROL_SAFETY_NOTE },
      cordless: {
        enabled: true,
        label: 'Cordless',
        surchargeCents: cordlessCents,
        note: 'Upgrade how you raise and lower the shade. This does not set the no-drill mount.',
      },
      motorized: {
        enabled: true,
        label: 'Motorized',
        surchargeCents: motorizedCents,
        note: 'We confirm the motor and control details as we go over your order.',
      },
    };
  }

  function placeholderVariants() {
    return { cord: 0, cordless: 0, motorized: 0 };
  }

  const ROLLER_CUSTOMIZER_FLOW = [
    'installation_mount',
    'headrail_style',
    'fabric_color',
    'measurements',
    'control_method',
    'bottom_rail',
    'accessories',
    'window_details',
    'review',
  ];

  const ROLLER_HEADRAILS = [
    'no-drill-open-roll',
    'no-drill-fabric-cassette',
    'no-drill-square-cassette',
    'standard-open-roll',
    'standard-fabric-cassette',
    'standard-beveled-cassette',
    'standard-square-cassette',
  ];

  const ROLLER_CHAIN_HEADRAILS = ROLLER_HEADRAILS.filter(
    (headrail) => headrail !== 'no-drill-square-cassette',
  );

  function rollerHardwareOptionGroups() {
    return [
      {
        id: 'installation_method',
        stage: 'installation',
        label: 'Installation method',
        note: 'First, choose how to mount your shade. Then pick hardware that fits that mount.',
        required: true,
        display: 'cards',
        options: [
          {
            id: 'no-drill',
            label: 'No-Drill Mount',
            note: 'Fits inside the opening. No mount screws are needed.',
          },
          {
            id: 'standard-bracket',
            label: 'Standard Bracket Mount',
            note: 'The brackets screw in. They can go inside or outside the opening.',
          },
        ],
      },
      {
        id: 'headrail_style',
        stage: 'headrail',
        label: 'Headrail style',
        note: 'Choose a headrail that works with your mount.',
        required: true,
        dependsOn: ['installation_method'],
        waitingLabel: 'Choose how to mount your shade first.',
        display: 'cards',
        options: [
          {
            id: 'no-drill-open-roll',
            label: 'No-Drill Open Roll',
            selectorMediaKey: 'headrail-no-drill-open-roll',
            fabricWrapped: false,
            requires: { installation_method: ['no-drill'] },
          },
          {
            id: 'no-drill-fabric-cassette',
            label: 'No-Drill Fabric-Wrapped Cassette',
            note: 'The front of the cassette goes with the fabric you pick.',
            selectorMediaKey: 'headrail-fabric-wrapped-cassette',
            fabricWrapped: true,
            requires: { installation_method: ['no-drill'] },
          },
          {
            id: 'no-drill-square-cassette',
            label: 'No-Drill Square Cassette',
            note: 'A square shape with a built-in mount that locks by pressure.',
            selectorMediaKey: 'headrail-no-drill-square-cassette',
            fabricWrapped: false,
            requires: { installation_method: ['no-drill'] },
          },
          {
            id: 'standard-open-roll',
            label: 'Standard Bracket Open Roll',
            selectorMediaKey: 'headrail-standard-open-roll',
            fabricWrapped: false,
            requires: { installation_method: ['standard-bracket'] },
          },
          {
            id: 'standard-fabric-cassette',
            label: 'Standard Bracket Fabric-Wrapped Cassette',
            note: 'The front of the cassette goes with the fabric you pick.',
            selectorMediaKey: 'headrail-fabric-wrapped-cassette',
            fabricWrapped: true,
            requires: { installation_method: ['standard-bracket'] },
          },
          {
            id: 'standard-beveled-cassette',
            label: 'Standard Bracket Beveled Cassette',
            selectorMediaKey: 'headrail-beveled-cassette',
            fabricWrapped: false,
            requires: { installation_method: ['standard-bracket'] },
          },
          {
            id: 'standard-square-cassette',
            label: 'Standard Bracket Square Cassette',
            selectorMediaKey: 'headrail-standard-square-cassette',
            fabricWrapped: false,
            requires: { installation_method: ['standard-bracket'] },
          },
        ],
      },
      {
        id: 'hardware_finish',
        stage: 'headrail',
        label: 'Hardware finish',
        note: 'Choose a finish for your headrail.',
        activeWhen: { headrail_style: ROLLER_HEADRAILS },
        requiredWhen: { headrail_style: ROLLER_HEADRAILS },
        dependsOn: ['headrail_style'],
        waitingLabel: 'Choose a headrail style first.',
        defaultOption: 'white',
        hideWhenSingleOption: true,
        display: 'swatch',
        options: [
          { id: 'white', label: 'White', canonicalFinishId: 'white', swatchHex: '#f1efe8', requires: { headrail_style: ROLLER_HEADRAILS } },
          {
            id: 'beige',
            label: 'Beige',
            canonicalFinishId: 'beige',
            swatchHex: '#d7c9aa',
            requires: { headrail_style: ['no-drill-square-cassette', 'standard-square-cassette'] },
          },
          {
            id: 'gray',
            label: 'Gray',
            canonicalFinishId: 'gray',
            swatchHex: '#9a9b98',
            requires: { headrail_style: ['no-drill-square-cassette', 'standard-square-cassette'] },
          },
          {
            id: 'silver',
            label: 'Silver',
            canonicalFinishId: 'silver',
            swatchHex: '#a7a9a8',
            requires: { headrail_style: ['standard-open-roll', 'standard-beveled-cassette'] },
          },
          {
            id: 'black',
            label: 'Black',
            canonicalFinishId: 'black',
            swatchHex: '#252525',
            requires: { headrail_style: ['standard-open-roll', 'standard-beveled-cassette', 'no-drill-square-cassette', 'standard-square-cassette'] },
          },
        ],
      },
      {
        id: 'mount_location',
        stage: 'installation',
        label: 'Mount location',
        note: 'No-Drill goes inside the opening. Standard brackets can go inside or out.',
        required: true,
        inlineSubchoice: true,
        hideWhenSingleOption: true,
        dependsOn: ['installation_method'],
        waitingLabel: 'Choose how to mount your shade first.',
        defaults: [{ when: { installation_method: ['no-drill'] }, option: 'inside' }],
        display: 'cards',
        options: [
          { id: 'inside', label: 'Inside Mount', requires: { installation_method: ['no-drill', 'standard-bracket'] } },
          { id: 'outside', label: 'Outside Mount', requires: { installation_method: ['standard-bracket'] } },
        ],
      },
      {
        id: 'bottom_rail',
        stage: 'bottom-rail',
        label: 'Bottom rail',
        note: 'Choose a bottom-rail style for your shade.',
        required: true,
        compatibilityStatus: 'compatibility-confirmation-required',
        display: 'cards',
        options: [
          { id: 'fabric-wrapped', label: 'Fabric-Wrapped Bottom Rail', selectorMediaKey: 'bottom-rail-fabric-wrapped' },
          { id: 'square', label: 'Square Bottom Rail', selectorMediaKey: 'bottom-rail-square' },
        ],
      },
    ];
  }

  function rollerControls() {
    const controls = controlLadder(15000, 30000);
    controls.cord.label = 'Chain';
    controls.cord.cardNote = 'Manual continuous-loop control.';
    controls.cord.selectorMediaKey = 'control-chain';
    controls.cord.requires = { headrail_style: ROLLER_CHAIN_HEADRAILS };
    controls.cordless.requires = {
      headrail_style: [
        'no-drill-fabric-cassette',
        'standard-open-roll',
        'standard-fabric-cassette',
        'standard-beveled-cassette',
        'no-drill-square-cassette',
        'standard-square-cassette',
      ],
    };
    controls.cordless.selectorMediaKey = 'control-cordless';
    controls.motorized.requires = { headrail_style: ROLLER_HEADRAILS };
    controls.motorized.selectorMediaKey = 'control-motorized';
    return controls;
  }

  function rollerFamilyOptions() {
    return catalogData.roller.families.map((family) => ({
      id: family.id,
      label: family.label,
      requires: {
        fabric_type: family.fabricTypes,
        ...(family.openness ? { solar_openness: family.openness } : {}),
      },
    }));
  }

  function rollerColorOptions() {
    return catalogData.roller.variants.map((variant) => ({
      id: variant.id,
      label: variant.label,
      requires: {
        fabric_type: [variant.fabricType],
        fabric_family: [variant.familyId],
        ...(variant.openness ? { solar_openness: [variant.openness] } : {}),
      },
    }));
  }

  function cellularFamilyOptions() {
    return catalogData.cellular.families.map((family) => ({
      id: family.id,
      label: family.label,
      requires: { fabric_type: [family.fabricType] },
    }));
  }

  function cellularColorOptions() {
    return catalogData.cellular.variants.map((variant) => ({
      id: variant.id,
      label: variant.label,
      requires: {
        fabric_type: [variant.fabricType],
        fabric_family: [variant.familyId],
      },
    }));
  }

  function constructionFamilyOptions(catalogKey) {
    return catalogData[catalogKey].families.map((family) => ({
      id: family.id,
      label: family.label,
      requires: { light_control: [family.lightControl] },
    }));
  }

  function constructionColorOptions(catalogKey) {
    return catalogData[catalogKey].variants.map((variant) => ({
      id: variant.id,
      label: variant.label,
      requires: {
        light_control: [variant.lightControl],
        fabric_family: [variant.familyId],
      },
    }));
  }

  const rollerHardwareGroups = rollerHardwareOptionGroups();

  const categories = {
    'roller-shades': {
      id: 'roller-shades',
      label: 'Roller Shades',
      shortLabel: 'Roller',
      customizerFlow: ROLLER_CUSTOMIZER_FLOW,
      controlPreviewInstallation: 'no-drill',
      requireExplicitControlChoice: true,
      lockedOptionLabels: {
        fabric_type: {
          'light-filtering': 'Light Filtering Roller Shades',
          blackout: 'Blackout Roller Shades',
          solar: 'Solar Roller Shades',
        },
      },
      catalogEligible: true,
      configurationEnabled: true,
      validationLabel: 'Pick No-Drill or Standard Bracket Mount. Then pick hardware that works with it.',
      mountValidation: { status: 'documented-sample-pending' },
      measurement: {
        minWidth: 19.75,
        maxWidth: 78.625,
        minHeight: 24,
        maxHeight: 94.375,
        increment: 0.125,
      },
      optionGroups: [
        rollerHardwareGroups.find((group) => group.id === 'installation_method'),
        {
          id: 'fabric_type',
          label: 'Fabric type',
          note: 'Light filtering and solar fabric can both cut glare. They are made in different ways.',
          required: true,
          display: 'cards',
          options: [
            {
              id: 'light-filtering',
              label: 'Light Filtering',
              note: 'Solid fabric that lets soft light in. It gives more privacy than solar fabric. It has no openness rating.',
            },
            {
              id: 'blackout',
              label: 'Blackout',
              note: 'Fabric that blocks light to make the room as dark as possible. Light can still get in at the edges.',
            },
            {
              id: 'solar',
              label: 'Solar',
              note: 'Open screen mesh cuts glare and lets you see out by day. The percentage shows how open the weave is. It does not give privacy at night.',
            },
          ],
        },
        {
          id: 'solar_openness',
          label: 'Solar openness',
          note: 'A lower percentage means a tighter weave. A higher percentage lets in more view and light.',
          activeWhen: { fabric_type: ['solar'] },
          requiredWhen: { fabric_type: ['solar'] },
          display: 'cards',
          options: [
            { id: '1', label: '1% openness' },
            { id: '3', label: '3% openness' },
            { id: '5', label: '5% openness' },
          ],
        },
        {
          id: 'fabric_family',
          label: 'Fabric collection',
          note: 'Pick a fabric collection for your shade.',
          required: true,
          dependsOn: ['fabric_type'],
          waitingLabel: 'Choose a fabric type first.',
          display: 'cards',
          options: rollerFamilyOptions(),
        },
        {
          id: 'fabric_color',
          label: 'Color',
          note: 'Screen colors vary. Check your color with a real sample before you order.',
          required: true,
          dependsOn: ['fabric_family'],
          waitingLabel: 'Pick a fabric collection before you go on.',
          display: 'cards',
          defaults: [
            {
              when: { fabric_family: ['NDR-RL-TX-001'], fabric_type: ['light-filtering'] },
              option: 'NDR-RL-TX-001-LF-C01',
            },
            {
              when: { fabric_family: ['NDR-RL-TX-001'], fabric_type: ['blackout'] },
              option: 'NDR-RL-TX-001-BO-C01',
            },
          ],
          options: rollerColorOptions(),
        },
        rollerHardwareGroups.find((group) => group.id === 'headrail_style'),
        rollerHardwareGroups.find((group) => group.id === 'hardware_finish'),
        rollerHardwareGroups.find((group) => group.id === 'mount_location'),
        rollerHardwareGroups.find((group) => group.id === 'bottom_rail'),
      ],
      defaultMount: 'no-drill-inside',
      mounts: {
        'no-drill-inside': {
          label: 'Inside mount · No-Drill',
          enabled: true,
          allowedMountTypes: ['inside'],
          surchargeCents: 0,
          note: 'Uses the two sides inside the opening.',
        },
        'standard-inside': {
          label: 'Inside mount · Standard brackets',
          enabled: true,
          allowedMountTypes: ['inside'],
          surchargeCents: 0,
          note: 'The brackets screw in on the inside of the window opening.',
        },
        'standard-outside': {
          label: 'Outside mount · Standard brackets',
          enabled: true,
          allowedMountTypes: ['outside'],
          surchargeCents: 0,
          note: 'The brackets screw in on the outside of the window opening.',
        },
      },
      controlOrder: ['cord', 'cordless', 'motorized'],
      controls: rollerControls(),
      upgrades: {},
      accessories: {},
      accessoryNone: {
        id: 'none',
        label: 'No accessories',
        note: 'No add-ons chosen.',
        selectorMediaKey: 'accessory-none',
      },
      priceBands: [
        { id: 'S', maxWidth: 36, maxHeight: 48, baseCents: 65000, variantIds: placeholderVariants('roller', 'S') },
        { id: 'M', maxWidth: 60, maxHeight: 72, baseCents: 85000, variantIds: placeholderVariants('roller', 'M') },
        { id: 'L', maxWidth: 96, maxHeight: 120, baseCents: 105000, variantIds: placeholderVariants('roller', 'L') },
      ],
    },

    'cellular-shades': {
      id: 'cellular-shades',
      label: 'Cellular / Honeycomb Shades',
      shortLabel: 'Cellular',
      catalogEligible: true,
      configurationEnabled: true,
      validationLabel: 'Made to go inside the opening with no drilling.',
      mountValidation: { status: 'catalog-documented-sample-pending' },
      measurement: {
        minWidth: 24,
        maxWidth: 78.625,
        minHeight: 12,
        maxHeight: 90.5,
        increment: 0.125,
      },
      optionGroups: [
        {
          id: 'fabric_type',
          label: 'Fabric type',
          required: true,
          display: 'cards',
          options: [
            { id: 'light-filtering', label: 'Light Filtering' },
            { id: 'blackout', label: 'Blackout' },
            { id: 'semi-sheer', label: 'Semi-Sheer' },
            { id: 'dual-blackout', label: 'Dual Blackout' },
          ],
        },
        {
          id: 'fabric_family',
          label: 'Fabric collection',
          required: true,
          dependsOn: ['fabric_type'],
          waitingLabel: 'Choose a fabric type first.',
          display: 'cards',
          options: cellularFamilyOptions(),
        },
        {
          id: 'fabric_color',
          label: 'Color',
          note: 'Screen colors vary. Check your color with a real sample before you order.',
          required: true,
          dependsOn: ['fabric_family'],
          waitingLabel: 'Pick a fabric collection before you go on.',
          display: 'cards',
          options: cellularColorOptions(),
        },
        {
          id: 'operation',
          label: 'Shade operation',
          required: true,
          display: 'cards',
          options: [
            { id: 'standard', label: 'Standard' },
            { id: 'day-night', label: 'Day & Night' },
            { id: 'top-down-bottom-up', label: 'Top-down bottom-up' },
          ],
        },
      ],
      catalogLimitsMm: {
        noDrillWidth: { min: 350, max: 2000 },
        noDrillHeight: { min: 300, max: 3000 },
        sharedControlEnvelope: { minWidth: 600, maxWidth: 2000, minHeight: 300, maxHeight: 2300 },
      },
      defaultMount: 'catalog-no-drill-inside',
      mounts: {
        'catalog-no-drill-inside': {
          label: 'Inside mount · No-drill headrail',
          enabled: true,
          allowedMountTypes: ['inside'],
          surchargeCents: 0,
          minimumDepthMm: 70,
          note: 'The headrail depth depends on your choices. Check how much depth you need to mount it before you order.',
        },
      },
      controlOrder: ['cord', 'cordless', 'motorized'],
      controls: controlLadder(12500, 32500),
      upgrades: {
        bridge: { enabled: true, label: 'Smart-home bridge', surchargeCents: 7500, requiresControls: ['motorized'] },
      },
      priceBands: [
        { id: 'S', maxWidth: 36, maxHeight: 48, baseCents: 70000, variantIds: placeholderVariants('cellular', 'S') },
        { id: 'M', maxWidth: 60, maxHeight: 72, baseCents: 92500, variantIds: placeholderVariants('cellular', 'M') },
        { id: 'L', maxWidth: 78.625, maxHeight: 90.5, baseCents: 117500, variantIds: placeholderVariants('cellular', 'L') },
      ],
    },

    'shangri-la-sheer-shades': {
      id: 'shangri-la-sheer-shades',
      label: 'Sheer Shades',
      shortLabel: 'Sheer',
      catalogEligible: true,
      configurationEnabled: true,
      validationLabel: 'Traditional Mount. You need to drill and screw in the brackets.',
      mountValidation: { status: 'documented-drilled-only' },
      measurement: { minWidth: 19.75, maxWidth: 78.625, minHeight: 20, maxHeight: 94.375, increment: 0.125 },
      optionGroups: [
        {
          id: 'light_control', label: 'Light control', required: true, display: 'cards',
          options: [
            { id: 'light-filtering', label: 'Light Filtering' },
            { id: 'room-darkening', label: 'Room Darkening' },
            { id: 'sheer', label: 'Sheer' },
          ],
        },
        {
          id: 'fabric_family', label: 'Fabric collection', required: true, display: 'cards',
          dependsOn: ['light_control'], waitingLabel: 'Choose how much light to let in first.',
          options: constructionFamilyOptions('shangriLa'),
        },
        {
          id: 'fabric_color', label: 'Color', required: true, display: 'cards',
          dependsOn: ['fabric_family'], waitingLabel: 'Pick a fabric collection before you go on.',
          note: 'Screen colors vary. Check your color with a real sample.',
          options: constructionColorOptions('shangriLa'),
        },
      ],
      defaultMount: 'traditional-inside',
      mounts: {
        'traditional-inside': {
          label: 'Inside mount · Traditional screw brackets',
          enabled: true,
          allowedMountTypes: ['inside'],
          surchargeCents: 0,
          note: 'The cassette sits inside the opening. Brackets screw in to hold it.',
        },
      },
      controls: {
        cord: {
          enabled: true,
          label: 'Manual chain',
          surchargeCents: 0,
          note: 'Manual chain operation with cassette. The continuous loop requires a secured tension device.',
        },
        cordless: { enabled: false, label: 'Cordless', surchargeCents: 0, note: 'Not available for this shade.' },
        motorized: {
          enabled: true,
          label: 'Motorized',
          surchargeCents: 30000,
          note: 'A battery motor with a remote you hold in your hand.',
        },
      },
      controlOrder: ['cord', 'motorized'],
      upgrades: {},
      priceBands: [
        { id: 'S', maxWidth: 36, maxHeight: 48, baseCents: 75000, variantIds: { cord: 0, motorized: 0 } },
        { id: 'M', maxWidth: 60, maxHeight: 72, baseCents: 97500, variantIds: { cord: 0, motorized: 0 } },
        { id: 'L', maxWidth: 90.5, maxHeight: 98.25, baseCents: 125000, variantIds: { cord: 0, motorized: 0 } },
      ],
    },

    'zebra-shades': {
      id: 'zebra-shades',
      label: 'Zebra Shades',
      shortLabel: 'Zebra',
      catalogEligible: true,
      configurationEnabled: true,
      validationLabel: 'Made to go inside the opening with no drilling.',
      mountValidation: { status: 'documented-sample-pending' },
      measurement: { minWidth: 19.75, maxWidth: 78.625, minHeight: 24, maxHeight: 94.375, increment: 0.125 },
      optionGroups: [
        {
          id: 'light_control', label: 'Light control', required: true, display: 'cards',
          options: [
            { id: 'light-filtering', label: 'Light Filtering' },
            { id: 'room-darkening', label: 'Room Darkening' },
            { id: 'blackout', label: 'Blackout' },
          ],
        },
        {
          id: 'fabric_family', label: 'Fabric collection', required: true, display: 'cards',
          dependsOn: ['light_control'], waitingLabel: 'Choose how much light to let in first.',
          options: constructionFamilyOptions('zebra'),
        },
        {
          id: 'fabric_color', label: 'Color', required: true, display: 'cards',
          dependsOn: ['fabric_family'], waitingLabel: 'Pick a fabric collection before you go on.',
          note: 'Screen colors vary. Check your color with a real sample.',
          options: constructionColorOptions('zebra'),
        },
      ],
      mounts: {},
      controls: controlLadder(15000, 30000),
      controlOrder: ['cord', 'cordless', 'motorized'],
      upgrades: {},
      priceBands: [],
    },
    'two-inch-blinds': {
      id: 'two-inch-blinds',
      label: '2 in Blinds',
      catalogEligible: false,
      mountValidation: { status: 'unconfirmed' },
      measurement: { minWidth: 19.75, maxWidth: 78.625, minHeight: 24, maxHeight: 96, increment: 0.125 },
      optionGroups: [
        { id: 'slat_color', label: 'Slat color', required: true, options: commonColors },
        { id: 'slat_material', label: 'Slat material', required: true, options: [] },
        { id: 'tilt', label: 'Tilt method', required: true, options: [] },
      ],
      mounts: {},
      controls: controlLadder(15000, 32500),
      controlOrder: ['cord', 'cordless', 'motorized'],
      priceBands: [],
    },
    'aluminum-blinds': {
      id: 'aluminum-blinds',
      label: 'Aluminum Blinds',
      catalogEligible: false,
      mountValidation: { status: 'unconfirmed' },
      measurement: { minWidth: 19.75, maxWidth: 78.625, minHeight: 12, maxHeight: 96, increment: 0.125 },
      optionGroups: [
        { id: 'slat_color', label: 'Slat color', required: true, options: commonColors },
        { id: 'slat_width', label: 'Slat width', required: true, options: [] },
        { id: 'tilt', label: 'Tilt method', required: true, options: [] },
      ],
      mounts: {},
      controls: controlLadder(12500, 30000),
      controlOrder: ['cord', 'cordless', 'motorized'],
      priceBands: [],
    },
  };

  const orderPricing = {
    discountTiers: [
      { minQuantity: 5, percent: 15 },
      { minQuantity: 3, percent: 10 },
      { minQuantity: 2, percent: 5 },
    ],
  };

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  const rollerHardwareFields = [
    'measurement',
    'defaultMount',
    'mounts',
    'controlPreviewInstallation',
    'controlOrder',
    'controls',
    'priceBands',
  ];
  rollerHardwareFields.forEach((field) => {
    categories['zebra-shades'][field] = clone(categories['roller-shades'][field]);
  });
  const rollerHardwareGroupIds = [
    'installation_method',
    'headrail_style',
    'hardware_finish',
    'mount_location',
    'bottom_rail',
  ];
  const sharedRollerGroups = categories['roller-shades'].optionGroups
    .filter((group) => rollerHardwareGroupIds.includes(group.id));
  categories['zebra-shades'].optionGroups = [
    clone(sharedRollerGroups.find((group) => group.id === 'installation_method')),
    ...categories['zebra-shades'].optionGroups,
    ...sharedRollerGroups
      .filter((group) => group.id !== 'installation_method')
      .map(clone),
  ];
  // Zebra retains its existing pilot journey and placeholder add-ons until the
  // Zebra retains its existing mount route and wording while sharing the
  // owner-approved headrail-before-fabric sequence.
  categories['zebra-shades'].customizerFlow = [
    'installation_method',
    'headrail_style',
    'fabric_color',
    'mount_location',
    'measurements',
    'control_method',
    'bottom_rail',
    'remaining_details',
    'review',
  ];
  categories['zebra-shades'].upgrades = {
    'side-blocker': { enabled: true, label: 'Side light blocker', surchargeCents: 12000, allowedMounts: ['no-drill-inside'] },
    bridge: { enabled: true, label: 'Smart-home bridge', surchargeCents: 7500, requiresControls: ['motorized'] },
  };
  const zebraMountGroup = categories['zebra-shades'].optionGroups.find((group) => group.id === 'mount_location');
  if (zebraMountGroup) {
    zebraMountGroup.stage = 'mount';
    zebraMountGroup.inlineSubchoice = false;
    zebraMountGroup.hideWhenSingleOption = false;
  }
  categories['zebra-shades'].validationLabel = categories['roller-shades'].validationLabel;

  function conditionsMatch(conditions, selections) {
    return !conditions || Object.entries(conditions).every(
      ([id, allowed]) => allowed.includes(selections[id]),
    );
  }

  function isGroupActive(group, selections) {
    return conditionsMatch(group.activeWhen, selections || {});
  }

  function availableOptions(group, selections) {
    const selected = selections || {};
    if (!isGroupActive(group, selected)) return [];
    if ((group.dependsOn || []).some((id) => !selected[id])) return [];
    return (group.options || []).filter((option) => conditionsMatch(option.requires, selected));
  }

  function availableControls(category, selections) {
    const selected = selections || {};
    const controls = (category.controlOrder || []).map((id) => ({ id, ...category.controls[id] }));
    if (selected.headrail_style || !category.controlPreviewInstallation) {
      return controls.filter((control) => control.enabled && conditionsMatch(control.requires, selected));
    }

    const projected = {
      ...selected,
      installation_method: selected.installation_method || category.controlPreviewInstallation,
    };
    const headrailGroup = (category.optionGroups || []).find((group) => group.id === 'headrail_style');
    const compatibleHeadrails = headrailGroup
      ? availableOptions(headrailGroup, projected).map((option) => option.id)
      : [];
    if (!compatibleHeadrails.length) return [];

    return controls.filter((control) => {
      if (!control.enabled) return false;
      const requirements = control.requires || {};
      const { headrail_style: allowedHeadrails, ...otherRequirements } = requirements;
      return conditionsMatch(otherRequirements, projected)
        && (!allowedHeadrails || compatibleHeadrails.every((id) => allowedHeadrails.includes(id)));
    });
  }

  function defaultOption(group, selections) {
    const selected = selections || {};
    const configured = (group.defaults || []).find((entry) => conditionsMatch(entry.when, selected));
    return configured?.option || group.defaultOption || '';
  }

  function getCategory(id) {
    return categories[id] ? clone(categories[id]) : null;
  }

  function listCatalogCategories() {
    return Object.values(categories).filter((category) => category.catalogEligible).map(clone);
  }

  function buildRules(id) {
    const category = getCategory(id);
    if (!category) throw new Error(`Unknown no-drill category: ${id}`);
    return {
      ...category,
      version: 5,
      mode: 'build-preview',
      currency: 'USD',
      checkoutEnabled: false,
      orderPricing: clone(orderPricing),
    };
  }

  return {
    categories,
    orderPricing,
    getCategory,
    listCatalogCategories,
    buildRules,
    isGroupActive,
    availableOptions,
    availableControls,
    defaultOption,
  };
});
